import React from "react";
import { Link } from "react-router-dom";
import { openCookiePreferences } from "../cookies/CookieConsent";

const LINK = "underline underline-offset-2 text-slate-300 hover:text-sky-300";

export function SiteFooter({ className = "" }) {
  return (
    <footer data-testid="site-footer" className={`mt-12 border-t border-slate-800/70 pt-6 pb-4 text-xs text-slate-400 ${className}`}>
      <nav aria-label="Legal and accessibility" className="flex flex-wrap items-center gap-x-4 gap-y-2">
        <Link to="/privacy" className={LINK} data-testid="footer-privacy-link">Privacy Policy</Link>
        <Link to="/accessibility" className={LINK} data-testid="footer-accessibility-link">Accessibility Statement</Link>
        <Link to="/ccpa-opt-out" className={LINK} data-testid="footer-ccpa-link">Do Not Sell or Share My Personal Information</Link>
        <Link to="/cookies" className={LINK} data-testid="footer-cookies-link">Cookie Policy</Link>
        <button type="button" onClick={openCookiePreferences} className={LINK} data-testid="footer-cookie-prefs">Cookie preferences</button>
        <Link to="/terms" className={LINK} data-testid="footer-terms-link">Terms</Link>
        <Link to="/compliance" className={LINK} data-testid="footer-compliance-link">Compliance</Link>
      </nav>
      <p className="mt-4">© {new Date().getFullYear()} The Packs Sanctuary · <a href="mailto:howl@thepackssanctuary.com" className={LINK}>howl@thepackssanctuary.com</a></p>
    </footer>
  );
}

export function SkipLink() {
  return <a href="#main-content" className="skip-link" data-testid="skip-to-main">Skip to main content</a>;
}
